export interface GetAntrepoListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAntrepoListPagingAndFilterResponseData
}

export interface GetAntrepoListPagingAndFilterResponseData {
    items: GetAntrepoListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetAntrepoListPagingAndFilterResponseItem {
    antrepoId: string
    companyId: string
    code: string
    baseAntrepoId: string
    phone1: string
    email: string
    antrepoTypeId: any
    palletCapacity: number
    volumeCapacity: number
    isCustomActive: boolean
    baseAntrepoName: string
    baseAntrepoCode: string
    antrepoTypeName: any
    antrepoAreas: GetAntrepoListPagingAndFilterResponseAntrepoArea[]
    antrepoShelfs: GetAntrepoListPagingAndFilterResponseAntrepoShelf[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetAntrepoListPagingAndFilterResponseAntrepoArea {
    antrepoAreaId: string
    antrepoId: string
    name: string
    antrepoAreaTypeId: string
    isCustomActive: boolean
    antrepoAreaTypeName: string
}

export interface GetAntrepoListPagingAndFilterResponseAntrepoShelf {
    antrepoShelfId: string
    antrepoId: string
    address: string
    antrepoShelfTypeId: string
    corridor: string
    column: string
    floor: string
    level: string
    isCustomActive: boolean
    antrepoShelfTypeName: string
}

export const initialGetAntrepoListPagingAndFilterResponseData: GetAntrepoListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}